import React from "react";
import { Card } from "semantic-ui-react";
import { observer } from "mobx-react-lite";
import {
  SalesTaxOptionType,
  TicketWorkflowSteps,
} from "../../../app/models/enums";
import CustomerDisplay from "./CustomerDisplay";
import VehicleDisplay from "./VehicleDisplay";
import TicketDisplay from "./TicketDisplay";
import { SettingsPricingTaxRateFormValues, SettingsTaxRatesDto } from "../../../app/models/pricing";

interface Props {
  workflowStep: TicketWorkflowSteps;
  disableButtons?: boolean;
  autoCapitalizeFirstLetter: boolean;
  setCustomer?: (value: boolean) => void;
  showTaxUpdate?: boolean;
  settingsPricingTaxRate?: SettingsPricingTaxRateFormValues;
  multipleTaxRates?: SettingsTaxRatesDto[];
  settingsSalesTaxOptions?: SalesTaxOptionType;
  //setTax?: (value: number) => void;
  //tax?: number;
  updated?: Date | undefined;
  setUseTicketItems?: React.Dispatch<React.SetStateAction<boolean>>;
}

export default observer(function Sidebar({
  workflowStep,
  disableButtons,
  autoCapitalizeFirstLetter,
  setCustomer,
  showTaxUpdate,
  multipleTaxRates,
  settingsSalesTaxOptions,
  updated,
}: Props) {
  return (
    <Card.Group>
      <TicketDisplay
        workflowStep={workflowStep}
        autoCapitalizeFirstLetter={autoCapitalizeFirstLetter}
        showTaxUpdate={showTaxUpdate}
        multipleTaxRates={multipleTaxRates}
        settingsSalesTaxOptions={settingsSalesTaxOptions}
        updated={updated}
      />
      <VehicleDisplay
        workflowStep={workflowStep}
        disableButtons={disableButtons}
        autoCapitalizeFirstLetter={autoCapitalizeFirstLetter}
      />
      <CustomerDisplay
        workflowStep={workflowStep}
        disableButtons={disableButtons}
        setCustomer={setCustomer}
      />
    </Card.Group>
  );
});
